import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './ModalForm.css';
import ContactForm from '../ContactForm/ContactForm';

Modal.setAppElement('#root');

const ModalContact = ({ contactFormData }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setModalIsOpen(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (modalIsOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [modalIsOpen]);

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Contact Form"
      className="modal fade-in"
      overlayClassName="overlay fade-in"
    >
      <div className="modal-content">
        <button onClick={closeModal} className="close-button">×</button>
        <h2 className="modal-title">{contactFormData.contactform_title}</h2>
        <p className="modal-subtitle">{contactFormData.contactform_subtitle}</p>
        <div className="modal-body">
          <ContactForm contactFormData={contactFormData} />
        </div>
      </div>
    </Modal>
  );
};

export default ModalContact;
